module.exports = __webpack_public_path__ + "static/media/logo-backstage.d3bf1efd.png";